import { useCallback, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import axios from 'axios';
import chevronLeft from '@/assets/chevron_left.svg';
import logo from '@/assets/logo.png';
import waitlist from '@/assets/waitlist.png';
import Button from '@/components/lib/Button';
import useRouterNavigation from '@/hooks/useRouterNavigation';

export const Route = createFileRoute('/_privateRoutes/onboarding/join-waitlist')({
  component: RouteComponent,
});

function RouteComponent() {
  const { back } = useRouterNavigation();
  const [joinedWaitlist, setJoinedWaitlist] = useState(false);

  const handleJoinWaitlist = useCallback(async () => {
    try {
      await axios.post('/api/onboarding/joinWaitlist');
    } catch {
      // ignore errors
    }
    setJoinedWaitlist(true);
  }, []);

  return (
    <div className="flex flex-col items-center min-h-screen bg-[#121212]">
      {/* Header */}
      <div className="relative flex flex-row items-center justify-center py-3 px-4 w-full">
        <img src={chevronLeft} alt="Back" className="absolute left-4 size-6 cursor-pointer" onClick={back} />
        <img src={logo} alt="Bond Logo" className="h-8 object-contain" />
      </div>
      <div className="flex flex-col items-center mt-[180px]">
        <img className="w-[237.33px] h-[92px]" src={waitlist} alt="Waitlist" />
        <h1 className="text-white text-[34px]/[40px] tracking-tight text-center max-w-[350px] font-bold mt-8 mb-3">
          {joinedWaitlist ? 'You are on the waitlist' : 'Join the waitlist'}
        </h1>
        <p className="text-white text-[16px]/[20px] tracking-tight text-center max-w-[350px] mb-10">
          {joinedWaitlist ? "We'll be in touch soon." : "You'll be notified once your spot is available"}
        </p>
        {!joinedWaitlist && (
          <Button size="lg" onClick={handleJoinWaitlist}>
            Join
          </Button>
        )}
      </div>
    </div>
  );
}
